import '.i{position:fixed;}.ssr-plugin'
import '.bs{top:0px;}.ssr-plugin'
import '.bz{left:0px;}.ssr-plugin'
import '.c0{right:0px;}.ssr-plugin'
import '.c1{bottom:0px;}.ssr-plugin'
import '.c2{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.c3{z-index:998;}.ssr-plugin'
import '.c4{transition:opacity 0.3s ease;}.ssr-plugin'
import '.c5{height:100vh;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.c6{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.c7{z-index:999;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.bi{justify-content:space-between;}.ssr-plugin'
import '.c8{padding:1.5rem;}.ssr-plugin'
import '.c9{border-bottom:var(--border-default);}.ssr-plugin'
import '.ag{flex-shrink:0;}.ssr-plugin'
import '.az{flex:1;}.ssr-plugin'
import '.ca{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="i bs bz c0 c1 c2 c3 c4"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="i bs c5 l t c6 c7 d e"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="d r bi c8 c9 ag"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="az ca c8"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
